<template>
  <v-select
    prepend-icon="mdi-timetable"
    v-model="timeCondID"
    :items="list"
    item-text="name"
    item-value="id"
    :label="$t('settings.fme.tc.label')"
    chips
  >
    <template v-slot:append-outer>
      <cp-help i18n="followme.timeCond"/>
    </template>
  </v-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'settings-followme-time-conditions',
  computed: {
    ...mapGetters({
      fmeData: 'settings/followme'
    }),
    timeCondID: {
      get: function () {
        return this.fmeData.timeConditionID
      },
      set: function (val) {
        this.dbg(`setting time condition id to ${val}`)
        this.setTimeCondID(val)
      }
    },
    list: function () {
      return [{ id: 0, name: this.$t('settings.fme.tc.none') }, ...this.fmeData.timeConditions]
    }
  },
  methods: {
    ...mapActions({
      setTimeCondID: 'settings/setFmeTimeCondID'
    })
  }
}
</script>

<style scoped>
</style>
